const Reducer = (state, action) => {
  switch (action.type) {
 
    case "UPDATE_HOME":
       return {
         ...state,
         home:action.payload,
         loading: false,
     }; 
    case "ADD_DOCUMENTS":
       return {
         ...state,
         home:action.payload,
         loading: false,
     }; 
   
    case "SET_LOADING":
        return {
          ...state,
          loading: true,
          
    };

      case "RESET_LOADING":
      return {
        ...state,
        loading: false,
    };
    default:
      return state;
   }
  };
    
    export default Reducer;
    